export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path === '/protected') return;

  const authStore = useAuthStore();

  const isLeavingCheckout =
    from.meta.layout === 'checkout' || from.meta.layout === 'order-confirmation';
  const isEnteringCheckout =
    to.meta.layout === 'checkout' || to.meta.layout === 'order-confirmation';

  if (authStore.guest && import.meta.client && isLeavingCheckout && !isEnteringCheckout) {
    const confirmCancellation = window.confirm(
      'Weet u zeker dat u het afrekenen wilt annuleren? Uw winkelwagenartikelen gaan definitief verloren.'
    );
    if (confirmCancellation) {
      authStore.is_guest_checkout = false;
      authStore.guest = null;
      const { useTrolleyStore } = await import('~/stores/trolley.store');
      const trolleyStore = useTrolleyStore();
      trolleyStore.destroyTrolley();
    } else {
      return false;
    }
  }

  if (
    to.meta.layout !== 'auth' &&
    to.path !== '/login' &&
    !authStore.is_authenticated &&
    !authStore.is_guest_checkout
  ) {
    const { useRootStore } = await import('~/stores/root.store');
    const rootStore = useRootStore();
    // indication - user has not taken any positive auth action
    rootStore.after_auth_intended_route = null;
  }
});
